<template>
  <div class="downlaod-paper-con">
    <p class="hint">{{ $t('test_download_desc') }}</p>
    <ul class="download-paper-list">
      <li class="paper-item" v-for="item in renderList" :key="item.id">
        <div class="paper-item__main">
          <img :src="require(`@/assets/images/hsk/${item.icon}`)" class="paper-item__main__img" />
          <span class="paper-item__main__txt">{{ item.name }}</span>
        </div>
        <div
          class="paper-item__button"
          @click="downLoad(item)"
          :style="item.loading ? 'opacity:0.6' : 'opacity:1'"
        >
          <i class="el-icon-loading" v-if="item.loading" style="margin-right: 3px"></i>
          <img
            v-else
            src="@/assets/images/hsk/download.png"
            alt=""
            class="paper-item__button__icon"
          />
          <span class="paper-item__button__txt"> {{ $t('download') }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { transferLanguage, deepClone } from '@/utils/utils'
export default {
  props: {
    resourceList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      transferLanguage,
      renderList: [],
      resourceIconList: [
        {
          iconName: 'zip.jpg',
          type: ['zip'],
        },
        {
          iconName: 'pdf.png',
          type: ['pdf'],
        },
        {
          iconName: 'image.png',
          type: ['png', 'jpg', 'jpeg'],
        },
        {
          iconName: 'word.png',
          type: ['word'],
        },
        {
          iconName: 'audio.png',
          type: ['mp3'],
        },
      ],
    }
  },
  watch: {
    resourceList: {
      handler(current) {
        current.forEach((item) => {
          item.suffix = this.getSuffix(item.resource_url)
          item.icon = this.getResourseIcon(item.resource_url)
          item.name = this.transferLanguage(item.resource_name_trans) + '.' + item.suffix
          item.loading = false
        })
        this.renderList = deepClone(current)
      },
      immediate: true,
    },
  },
  methods: {
    getSuffix(fileUrl) {
      const index = fileUrl.lastIndexOf('.')
      return fileUrl.substr(index + 1)
    },
    getResourseIcon(fileUrl) {
      const suffix = this.getSuffix(fileUrl)
      let iconObj = this.resourceIconList.find((item) => {
        return item.type.some((typeName) => suffix === typeName)
      })
      return iconObj ? iconObj.iconName : 'unknown.png'
    },
    downLoad(item) {
      if (item.loading) {
        return
      }
      item.loading = true
      const _this = this

      fetch(item.resource_url)
        .then((response) => {
          if (!response.ok) {
            item.loading = false
            throw new Error('Network response was not ok')
          }
          return response.blob()
        })
        .then((blob) => {
          // 创建一个下载链接
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          // 设置链接的下载属性，可以指定保存的文件名
          if (item.name) link.download = item.name
          // 将链接添加到页面，并触发点击
          document.body.appendChild(link)
          link.click()
          // 移除链接
          document.body.removeChild(link)
          item.loading = false
        })
        .catch((error) => {
          item.loading = false
          //common_text_file_error
          layer.open({
            title: '',
            closeBtn: 0,
            content: _this.$t('common_text_file_error'),
            btn: [_this.$t('button_common_ok')],
            yes: (index) => {
              layer.close(index)
            },
          })
          console.error('Error downloading image:', error)
        })
    },
  },
  mounted() {},
}
</script>

<style lang="scss">
.downlaod-paper-con {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #efeff1;
  padding: 35px 24px 45px;
  .hint {
    font-size: 16px;
    color: #2c2f46;
    border-bottom: 1px solid #efeff1;
    margin-bottom: 20px;
    padding-bottom: 20px;
  }
}

.download-paper-list {
  .paper-item {
    background: #fafafb;
    height: 45px;
    position: relative;
    margin-bottom: 14px;
    border-radius: 6px;
    padding: 10.5px 15.5px;
    &__main {
      display: flex;
      flex-wrap: nowrap;
      &__img {
        width: 24px;
        height: 24px;
        margin-right: 6.5px;
      }
      &__txt {
        font-size: 14px;
        line-height: 24px;
        color: #2c2f46;
      }
    }
    &__button {
      width: 122px;
      height: 28px;
      line-height: 28px;
      color: #fff;
      position: absolute;
      right: 12px;
      top: 8.5px;
      background: #515571;
      text-align: center;
      border-radius: 4px;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: 0.1s ease-in-out;
      &__loading {
        margin-right: 4px;
      }
      &__icon {
        width: 20px;
        height: 20px;
      }
    }
    &__button:hover {
      background: #2c2f46;
    }
  }
}
</style>
